// Local authentication service for compatibility

class LocalAuthService {
  constructor() {
    this.currentUser = null;
  }

  async signUp(credentials) {
    // Mock local user creation
    const localUser = {
      id: Date.now(),
      email: credentials.email,
      name: {
        first: credentials.firstName || '',
        last: credentials.lastName || ''
      },
      phone: credentials.phone || '',
      tenantId: credentials.tenantId || '',
      role: credentials.role || 'patient',
      createdAt: new Date().toISOString()
    };
    
    // Store in localStorage for persistence
    localStorage.setItem(`localUser_${localUser.email}`, JSON.stringify(localUser));
    localStorage.setItem('currentLocalUser', JSON.stringify(localUser));
    
    this.currentUser = localUser;
    return localUser;
  }

  async login(credentials) {
    // Try to retrieve user from localStorage
    const storedUser = localStorage.getItem(`localUser_${credentials.email}`);
    
    if (storedUser) {
      const localUser = JSON.parse(storedUser);
      localStorage.setItem('currentLocalUser', JSON.stringify(localUser));
      this.currentUser = localUser;
      return localUser;
    }
    
    // If no stored user, create a basic one
    const localUser = {
      id: Date.now(),
      email: credentials.email,
      name: { first: '', last: '' },
      phone: '',
      tenantId: '',
      role: 'patient'
    };
    
    localStorage.setItem('currentLocalUser', JSON.stringify(localUser));
    this.currentUser = localUser;
    return localUser;
  }

  logout() {
    localStorage.removeItem('currentLocalUser');
    this.currentUser = null;
  }

  getCurrentUser() {
    if (this.currentUser) {
      return this.currentUser;
    }
    
    const storedUser = localStorage.getItem('currentLocalUser');
    if (storedUser) {
      this.currentUser = JSON.parse(storedUser);
      return this.currentUser;
    }
    
    return null;
  }

  isAuthenticated() {
    return !!this.getCurrentUser();
  }
}

// Export singleton instance
export const AuthService = new LocalAuthService();
